<template src="./Keys.html"></template>

<script>
import {createNamespacedHelpers} from 'vuex';
import SearchQuery from "@/components/suppliers/components/SearchQuery"
import TopMenu from "@/components/suppliers/components/topMenu"

const {mapGetters, mapActions} = createNamespacedHelpers('suppliers/keys');

export default {
  name: "SuppliersKeys",
  components: {
    SearchQuery,
    TopMenu,
  },
  data() {
    return {
      showOverlay: false,
      keys: {},
      langList: ['en'],
      currentLang: 'en',
      timer: null,
    }
  },
  methods: {
    ...mapActions(['SAVE', 'GET_DATA']),
    keysChange() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.SAVE({th: this})
      }, 1500)
    },
    getData() {
      this.GET_DATA({th: this})
    },
    prepareValue() {
      // do initial fill KEYS if it empty
      for (let key in this.langList) {
        let lang = this.langList[key]
        if (this.KEYS[lang] === undefined || Object.keys(this.KEYS[lang]).length === 0) {
          this.keys[lang] = []
        } else {
          this.keys[lang] = this.KEYS[lang].slice(0)
        }
      }

      this.$store.commit('suppliers/keys/KEYS', Object.assign({}, this.keys))
    }
  },
  computed: {
    ...mapGetters([
      'KEYS',
    ]),
  },
  mounted() {
    this.getData()
  },
  created() {
    if (this.$store.getters.getAllowSection.indexOf('suppliers') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return
    }
  },
}
</script>

<style scoped>

.input-add-use {
  text-align: left;
}

.submit-button {
  text-align: right;
}

</style>